import muiUseMediaQuery from '@mui/material/useMediaQuery';

/**
 * @deprecated Please use new version from `@zeus/core/next`.
 * @see {@link https://zeus.serko.travel/?path=/docs/next-migration-guides-usemediaquery--overview Migration guide}
 */
const useMediaQuery = muiUseMediaQuery;

export { useMediaQuery };
